import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useTranslation } from 'react-i18next';
import { getPayrollConditionList } from '@store/HR/Payroll/PayrollConditionsSlice';

const useGetPayrollCondition = (payrollId: string | undefined) => {
  const dispatch = useAppDispatch();
  const { PayrollConditionList, loading, error } = useAppSelector(state => state.PayrollConditions);

  const { i18n } = useTranslation();

  useEffect(() => {
    if (payrollId) {
      dispatch(getPayrollConditionList(payrollId));
    }
  }, [payrollId]);

  const PayrollConditionCodes = PayrollConditionList?.filter(f => f.code !== null)?.map(item => ({
    id: item.id,
    name: i18n.language === 'en' ? item.name : item.name2,
    value: `#${item.code}#`,
    description: `(condition)`
    // description: i18n.language === 'en' ? item.name : item.name2
  }));

  return { PayrollConditionList, PayrollConditionCodes, loading, error };
};

export default useGetPayrollCondition;
